import { type InternalAxiosRequestConfig } from "axios";

import { LocalStorageService } from "@vega-core/service/LocalStorage.service";
import { isF2F, isGPPortal, isLPPortal } from "@vega-core/utils/global";
import { isTruthy } from "@vega-core/utils/isTruthy";

export const authInterceptor = async (config: InternalAxiosRequestConfig) => {
  const accessToken = LocalStorageService.getToken();

  if (isTruthy(accessToken)) {
    const oauthProvider = LocalStorageService.getOauthProvider();

    if (isTruthy(oauthProvider)) {
      config.headers["Authorization"] = `Bearer ${accessToken}`;

      return config;
    }
  }

  if (!isF2F && (isLPPortal || isGPPortal)) {
    config.withCredentials = true;
  }

  return config;
};
